import { Injectable } from '@angular/core';

import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addEvents(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/add-event`, Payload)
      .pipe(map(res => {
        return res;
      }),
        catchError(EventsService.handleError));
  }

  getEvents(): Observable<any> {
    return this.http.get(`${this.baseUrl}/events/get-events`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(EventsService.handleError));
  }

  getEventById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/get-event-by-id`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(EventsService.handleError));
  }
  deleteEventById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/delete-event-by-id`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(EventsService.handleError));
  }

  getEventBookingById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/get-event-booking-by-id`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(EventsService.handleError));
  }
  getEventBookingByEventId(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/get-event-booking-by-event-id`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(EventsService.handleError));
  }

  getEventBookingList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/events/get-event-booking-list`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(EventsService.handleError));
  }

  editEvents(Payload) {
    return this.http.post<any>(`${this.baseUrl}/events/update-event`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(EventsService.handleError));
  }
}
